import { Injectable } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { UrlValidator } from "@atenea-cms";
import { Award } from "./award.model";

@Injectable()
export class AwardFormService {
  constructor(private fb: FormBuilder) {}

  getForm(award: Award = new Award()): FormGroup {
    return this.fb.group({
      _id: [award._id],
      name: [award.name, Validators.required],
      source: [award.source, Validators.required],
      sourceUrl: [award.sourceUrl, [UrlValidator]],
      image: [award.image],
    });
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/awards/shared/award-form.service.ts